// Copyright ©️ 2026 eVolve MEP, LLC

const UUID_REGEXP_V4 = /^[0-9A-F]{8}-[0-9A-F]{4}-[4][0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}$/i;

// Validates "03aea1e1-95ed-4b4a-bcb5-a6652640f5c1" to be a UUID v4
export const uuIDValidator = (text: string) => UUID_REGEXP_V4.test(text);
